import React from 'react';
import MainLayout from '../components/MainLayout';


export default function ExpenseManagement() {
  return (
    <>
    <MainLayout>

    <div className='container'>

        <div className='row'>
        <div className='col-12'>
        ExpenseManagement
        </div>
        </div>

    </div>

    </MainLayout>
    </>
  )
}
